module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Empresa-Logotipo-2.6f4b91e4.png";